import "core-js/modules/es6.promise";
// defer() creates a new Promise and provides a way
// to `resolve` or `reject` that promise out of scope
export default function defer() {
  var resolve;
  var reject;
  var promise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
}